import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { Tooltip } from "@tql/ui-components-react/kendo/tooltip";
import { Button } from "@tql/ui-components-react/tql/buttons";
import {
	infoCircle,
	refreshCcw_01,
} from "@tql/ui-components-react/untitled/icons";

import { CustomerSearch } from "~/shared/components/customer-search/customer-search.tsx";
import type { Customer } from "~/shared/types/quote-details-types";

import {
	autoDispatchHeader,
	autoDispatchHeaderButtonGroup,
} from "./index.module.css";

type HeaderProps = {
	selectedCustomer: Customer | undefined;
	onCustomerChange: (customer: Customer | null) => void;
	onHandleRefresh: () => void;
};

export const Header = ({
	selectedCustomer,
	onCustomerChange,
	onHandleRefresh,
}: HeaderProps) => {
	return (
		<div className={autoDispatchHeader}>
			<CustomerSearch
				onCustomerChange={onCustomerChange}
				selectedCustomer={selectedCustomer}
				wrapperStyle={{ width: "300px" }}
			/>

			{!!selectedCustomer && (
				<div className={autoDispatchHeaderButtonGroup}>
					<Tooltip
						anchorElement={"target"}
						position={"left"}
						style={{ maxWidth: "30vw" }}
					>
						<Button
							startIcon={
								<SvgIcon
									icon={infoCircle}
									size={"xlarge"}
									style={{ pointerEvents: "none" }}
								/>
							}
							title={
								"If all set criteria is met, Auto Dispatching will automatically dispatch your shipment(s) after they have been Tendered. This Auto Dispatch will occur at the designated time set in the configuration table."
							}
							variant={"tertiary"}
						/>
					</Tooltip>
					<Button
						onClick={onHandleRefresh}
						startIcon={<SvgIcon icon={refreshCcw_01} size={"xlarge"} />}
						variant={"tertiary"}
					></Button>
				</div>
			)}
		</div>
	);
};
